/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SpacesImport } from './routes/spaces'
import { Route as SettingsImport } from './routes/settings'
import { Route as SearchImport } from './routes/search'
import { Route as ProfileImport } from './routes/profile'
import { Route as NotificationsImport } from './routes/notifications'
import { Route as MessagesImport } from './routes/messages'
import { Route as MembersImport } from './routes/members'
import { Route as LeaderboardImport } from './routes/leaderboard'
import { Route as EventsImport } from './routes/events'
import { Route as AdminImport } from './routes/admin'
import { Route as IndexImport } from './routes/index'
import { Route as SpacesIndexImport } from './routes/spaces/index'
import { Route as MessagesIndexImport } from './routes/messages/index'
import { Route as AdminIndexImport } from './routes/admin/index'
import { Route as SpacesSpaceIdImport } from './routes/spaces/$spaceId'
import { Route as ProfileUserIdImport } from './routes/profile/$userId'
import { Route as PostsNewImport } from './routes/posts/new'
import { Route as PostsPostIdImport } from './routes/posts/$postId'
import { Route as MessagesPartnerIdImport } from './routes/messages/$partnerId'
import { Route as AdminModeratorsImport } from './routes/admin/moderators'
import { Route as AdminModerationImport } from './routes/admin/moderation'
import { Route as AdminDefaultPinsImport } from './routes/admin/default-pins'
import { Route as AdminBansImport } from './routes/admin/bans'
import { Route as AdminAnalyticsImport } from './routes/admin/analytics'
import { Route as SpacesSpaceIdIndexImport } from './routes/spaces/$spaceId/index'
import { Route as SpacesSpaceIdPagesNewImport } from './routes/spaces/$spaceId/pages/new'
import { Route as SpacesSpaceIdPagesPageIdImport } from './routes/spaces/$spaceId/pages/$pageId'
import { Route as SpacesSpaceIdPagesPageIdIndexImport } from './routes/spaces/$spaceId/pages/$pageId/index'
import { Route as SpacesSpaceIdPagesPageIdEditImport } from './routes/spaces/$spaceId/pages/$pageId/edit'

// Create/Update Routes

const SpacesRoute = SpacesImport.update({
  id: '/spaces',
  path: '/spaces',
  getParentRoute: () => rootRoute,
} as any)

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const SearchRoute = SearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRoute,
} as any)

const ProfileRoute = ProfileImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRoute,
} as any)

const NotificationsRoute = NotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRoute,
} as any)

const MessagesRoute = MessagesImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => rootRoute,
} as any)

const MembersRoute = MembersImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRoute,
} as any)

const LeaderboardRoute = LeaderboardImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => rootRoute,
} as any)

const EventsRoute = EventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRoute,
} as any)

const AdminRoute = AdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SpacesIndexRoute = SpacesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SpacesRoute,
} as any)

const MessagesIndexRoute = MessagesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MessagesRoute,
} as any)

const AdminIndexRoute = AdminIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)

const SpacesSpaceIdRoute = SpacesSpaceIdImport.update({
  id: '/$spaceId',
  path: '/$spaceId',
  getParentRoute: () => SpacesRoute,
} as any)

const ProfileUserIdRoute = ProfileUserIdImport.update({
  id: '/$userId',
  path: '/$userId',
  getParentRoute: () => ProfileRoute,
} as any)

const PostsNewRoute = PostsNewImport.update({
  id: '/posts/new',
  path: '/posts/new',
  getParentRoute: () => rootRoute,
} as any)

const PostsPostIdRoute = PostsPostIdImport.update({
  id: '/posts/$postId',
  path: '/posts/$postId',
  getParentRoute: () => rootRoute,
} as any)

const MessagesPartnerIdRoute = MessagesPartnerIdImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => MessagesRoute,
} as any)

const AdminModeratorsRoute = AdminModeratorsImport.update({
  id: '/moderators',
  path: '/moderators',
  getParentRoute: () => AdminRoute,
} as any)

const AdminModerationRoute = AdminModerationImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => AdminRoute,
} as any)

const AdminDefaultPinsRoute = AdminDefaultPinsImport.update({
  id: '/default-pins',
  path: '/default-pins',
  getParentRoute: () => AdminRoute,
} as any)

const AdminBansRoute = AdminBansImport.update({
  id: '/bans',
  path: '/bans',
  getParentRoute: () => AdminRoute,
} as any)

const AdminAnalyticsRoute = AdminAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)

const SpacesSpaceIdIndexRoute = SpacesSpaceIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SpacesSpaceIdRoute,
} as any)

const SpacesSpaceIdPagesNewRoute = SpacesSpaceIdPagesNewImport.update({
  id: '/pages/new',
  path: '/pages/new',
  getParentRoute: () => SpacesSpaceIdRoute,
} as any)

const SpacesSpaceIdPagesPageIdRoute = SpacesSpaceIdPagesPageIdImport.update({
  id: '/pages/$pageId',
  path: '/pages/$pageId',
  getParentRoute: () => SpacesSpaceIdRoute,
} as any)

const SpacesSpaceIdPagesPageIdIndexRoute =
  SpacesSpaceIdPagesPageIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SpacesSpaceIdPagesPageIdRoute,
  } as any)

const SpacesSpaceIdPagesPageIdEditRoute =
  SpacesSpaceIdPagesPageIdEditImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => SpacesSpaceIdPagesPageIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminImport
      parentRoute: typeof rootRoute
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsImport
      parentRoute: typeof rootRoute
    }
    '/leaderboard': {
      id: '/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof LeaderboardImport
      parentRoute: typeof rootRoute
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersImport
      parentRoute: typeof rootRoute
    }
    '/messages': {
      id: '/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof MessagesImport
      parentRoute: typeof rootRoute
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsImport
      parentRoute: typeof rootRoute
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileImport
      parentRoute: typeof rootRoute
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/spaces': {
      id: '/spaces'
      path: '/spaces'
      fullPath: '/spaces'
      preLoaderRoute: typeof SpacesImport
      parentRoute: typeof rootRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsImport
      parentRoute: typeof AdminImport
    }
    '/admin/bans': {
      id: '/admin/bans'
      path: '/bans'
      fullPath: '/admin/bans'
      preLoaderRoute: typeof AdminBansImport
      parentRoute: typeof AdminImport
    }
    '/admin/default-pins': {
      id: '/admin/default-pins'
      path: '/default-pins'
      fullPath: '/admin/default-pins'
      preLoaderRoute: typeof AdminDefaultPinsImport
      parentRoute: typeof AdminImport
    }
    '/admin/moderation': {
      id: '/admin/moderation'
      path: '/moderation'
      fullPath: '/admin/moderation'
      preLoaderRoute: typeof AdminModerationImport
      parentRoute: typeof AdminImport
    }
    '/admin/moderators': {
      id: '/admin/moderators'
      path: '/moderators'
      fullPath: '/admin/moderators'
      preLoaderRoute: typeof AdminModeratorsImport
      parentRoute: typeof AdminImport
    }
    '/messages/$partnerId': {
      id: '/messages/$partnerId'
      path: '/$partnerId'
      fullPath: '/messages/$partnerId'
      preLoaderRoute: typeof MessagesPartnerIdImport
      parentRoute: typeof MessagesImport
    }
    '/posts/$postId': {
      id: '/posts/$postId'
      path: '/posts/$postId'
      fullPath: '/posts/$postId'
      preLoaderRoute: typeof PostsPostIdImport
      parentRoute: typeof rootRoute
    }
    '/posts/new': {
      id: '/posts/new'
      path: '/posts/new'
      fullPath: '/posts/new'
      preLoaderRoute: typeof PostsNewImport
      parentRoute: typeof rootRoute
    }
    '/profile/$userId': {
      id: '/profile/$userId'
      path: '/$userId'
      fullPath: '/profile/$userId'
      preLoaderRoute: typeof ProfileUserIdImport
      parentRoute: typeof ProfileImport
    }
    '/spaces/$spaceId': {
      id: '/spaces/$spaceId'
      path: '/$spaceId'
      fullPath: '/spaces/$spaceId'
      preLoaderRoute: typeof SpacesSpaceIdImport
      parentRoute: typeof SpacesImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexImport
      parentRoute: typeof AdminImport
    }
    '/messages/': {
      id: '/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof MessagesIndexImport
      parentRoute: typeof MessagesImport
    }
    '/spaces/': {
      id: '/spaces/'
      path: '/'
      fullPath: '/spaces/'
      preLoaderRoute: typeof SpacesIndexImport
      parentRoute: typeof SpacesImport
    }
    '/spaces/$spaceId/': {
      id: '/spaces/$spaceId/'
      path: '/'
      fullPath: '/spaces/$spaceId/'
      preLoaderRoute: typeof SpacesSpaceIdIndexImport
      parentRoute: typeof SpacesSpaceIdImport
    }
    '/spaces/$spaceId/pages/$pageId': {
      id: '/spaces/$spaceId/pages/$pageId'
      path: '/pages/$pageId'
      fullPath: '/spaces/$spaceId/pages/$pageId'
      preLoaderRoute: typeof SpacesSpaceIdPagesPageIdImport
      parentRoute: typeof SpacesSpaceIdImport
    }
    '/spaces/$spaceId/pages/new': {
      id: '/spaces/$spaceId/pages/new'
      path: '/pages/new'
      fullPath: '/spaces/$spaceId/pages/new'
      preLoaderRoute: typeof SpacesSpaceIdPagesNewImport
      parentRoute: typeof SpacesSpaceIdImport
    }
    '/spaces/$spaceId/pages/$pageId/edit': {
      id: '/spaces/$spaceId/pages/$pageId/edit'
      path: '/edit'
      fullPath: '/spaces/$spaceId/pages/$pageId/edit'
      preLoaderRoute: typeof SpacesSpaceIdPagesPageIdEditImport
      parentRoute: typeof SpacesSpaceIdPagesPageIdImport
    }
    '/spaces/$spaceId/pages/$pageId/': {
      id: '/spaces/$spaceId/pages/$pageId/'
      path: '/'
      fullPath: '/spaces/$spaceId/pages/$pageId/'
      preLoaderRoute: typeof SpacesSpaceIdPagesPageIdIndexImport
      parentRoute: typeof SpacesSpaceIdPagesPageIdImport
    }
  }
}

// Create and export the route tree

interface AdminRouteChildren {
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminBansRoute: typeof AdminBansRoute
  AdminDefaultPinsRoute: typeof AdminDefaultPinsRoute
  AdminModerationRoute: typeof AdminModerationRoute
  AdminModeratorsRoute: typeof AdminModeratorsRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminBansRoute: AdminBansRoute,
  AdminDefaultPinsRoute: AdminDefaultPinsRoute,
  AdminModerationRoute: AdminModerationRoute,
  AdminModeratorsRoute: AdminModeratorsRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface MessagesRouteChildren {
  MessagesPartnerIdRoute: typeof MessagesPartnerIdRoute
  MessagesIndexRoute: typeof MessagesIndexRoute
}

const MessagesRouteChildren: MessagesRouteChildren = {
  MessagesPartnerIdRoute: MessagesPartnerIdRoute,
  MessagesIndexRoute: MessagesIndexRoute,
}

const MessagesRouteWithChildren = MessagesRoute._addFileChildren(
  MessagesRouteChildren,
)

interface ProfileRouteChildren {
  ProfileUserIdRoute: typeof ProfileUserIdRoute
}

const ProfileRouteChildren: ProfileRouteChildren = {
  ProfileUserIdRoute: ProfileUserIdRoute,
}

const ProfileRouteWithChildren =
  ProfileRoute._addFileChildren(ProfileRouteChildren)

interface SpacesSpaceIdPagesPageIdRouteChildren {
  SpacesSpaceIdPagesPageIdEditRoute: typeof SpacesSpaceIdPagesPageIdEditRoute
  SpacesSpaceIdPagesPageIdIndexRoute: typeof SpacesSpaceIdPagesPageIdIndexRoute
}

const SpacesSpaceIdPagesPageIdRouteChildren: SpacesSpaceIdPagesPageIdRouteChildren =
  {
    SpacesSpaceIdPagesPageIdEditRoute: SpacesSpaceIdPagesPageIdEditRoute,
    SpacesSpaceIdPagesPageIdIndexRoute: SpacesSpaceIdPagesPageIdIndexRoute,
  }

const SpacesSpaceIdPagesPageIdRouteWithChildren =
  SpacesSpaceIdPagesPageIdRoute._addFileChildren(
    SpacesSpaceIdPagesPageIdRouteChildren,
  )

interface SpacesSpaceIdRouteChildren {
  SpacesSpaceIdIndexRoute: typeof SpacesSpaceIdIndexRoute
  SpacesSpaceIdPagesPageIdRoute: typeof SpacesSpaceIdPagesPageIdRouteWithChildren
  SpacesSpaceIdPagesNewRoute: typeof SpacesSpaceIdPagesNewRoute
}

const SpacesSpaceIdRouteChildren: SpacesSpaceIdRouteChildren = {
  SpacesSpaceIdIndexRoute: SpacesSpaceIdIndexRoute,
  SpacesSpaceIdPagesPageIdRoute: SpacesSpaceIdPagesPageIdRouteWithChildren,
  SpacesSpaceIdPagesNewRoute: SpacesSpaceIdPagesNewRoute,
}

const SpacesSpaceIdRouteWithChildren = SpacesSpaceIdRoute._addFileChildren(
  SpacesSpaceIdRouteChildren,
)

interface SpacesRouteChildren {
  SpacesSpaceIdRoute: typeof SpacesSpaceIdRouteWithChildren
  SpacesIndexRoute: typeof SpacesIndexRoute
}

const SpacesRouteChildren: SpacesRouteChildren = {
  SpacesSpaceIdRoute: SpacesSpaceIdRouteWithChildren,
  SpacesIndexRoute: SpacesIndexRoute,
}

const SpacesRouteWithChildren =
  SpacesRoute._addFileChildren(SpacesRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/events': typeof EventsRoute
  '/leaderboard': typeof LeaderboardRoute
  '/members': typeof MembersRoute
  '/messages': typeof MessagesRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRouteWithChildren
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/spaces': typeof SpacesRouteWithChildren
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bans': typeof AdminBansRoute
  '/admin/default-pins': typeof AdminDefaultPinsRoute
  '/admin/moderation': typeof AdminModerationRoute
  '/admin/moderators': typeof AdminModeratorsRoute
  '/messages/$partnerId': typeof MessagesPartnerIdRoute
  '/posts/$postId': typeof PostsPostIdRoute
  '/posts/new': typeof PostsNewRoute
  '/profile/$userId': typeof ProfileUserIdRoute
  '/spaces/$spaceId': typeof SpacesSpaceIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/spaces/': typeof SpacesIndexRoute
  '/spaces/$spaceId/': typeof SpacesSpaceIdIndexRoute
  '/spaces/$spaceId/pages/$pageId': typeof SpacesSpaceIdPagesPageIdRouteWithChildren
  '/spaces/$spaceId/pages/new': typeof SpacesSpaceIdPagesNewRoute
  '/spaces/$spaceId/pages/$pageId/edit': typeof SpacesSpaceIdPagesPageIdEditRoute
  '/spaces/$spaceId/pages/$pageId/': typeof SpacesSpaceIdPagesPageIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/events': typeof EventsRoute
  '/leaderboard': typeof LeaderboardRoute
  '/members': typeof MembersRoute
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRouteWithChildren
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bans': typeof AdminBansRoute
  '/admin/default-pins': typeof AdminDefaultPinsRoute
  '/admin/moderation': typeof AdminModerationRoute
  '/admin/moderators': typeof AdminModeratorsRoute
  '/messages/$partnerId': typeof MessagesPartnerIdRoute
  '/posts/$postId': typeof PostsPostIdRoute
  '/posts/new': typeof PostsNewRoute
  '/profile/$userId': typeof ProfileUserIdRoute
  '/admin': typeof AdminIndexRoute
  '/messages': typeof MessagesIndexRoute
  '/spaces': typeof SpacesIndexRoute
  '/spaces/$spaceId': typeof SpacesSpaceIdIndexRoute
  '/spaces/$spaceId/pages/new': typeof SpacesSpaceIdPagesNewRoute
  '/spaces/$spaceId/pages/$pageId/edit': typeof SpacesSpaceIdPagesPageIdEditRoute
  '/spaces/$spaceId/pages/$pageId': typeof SpacesSpaceIdPagesPageIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/events': typeof EventsRoute
  '/leaderboard': typeof LeaderboardRoute
  '/members': typeof MembersRoute
  '/messages': typeof MessagesRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/profile': typeof ProfileRouteWithChildren
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/spaces': typeof SpacesRouteWithChildren
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/bans': typeof AdminBansRoute
  '/admin/default-pins': typeof AdminDefaultPinsRoute
  '/admin/moderation': typeof AdminModerationRoute
  '/admin/moderators': typeof AdminModeratorsRoute
  '/messages/$partnerId': typeof MessagesPartnerIdRoute
  '/posts/$postId': typeof PostsPostIdRoute
  '/posts/new': typeof PostsNewRoute
  '/profile/$userId': typeof ProfileUserIdRoute
  '/spaces/$spaceId': typeof SpacesSpaceIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/spaces/': typeof SpacesIndexRoute
  '/spaces/$spaceId/': typeof SpacesSpaceIdIndexRoute
  '/spaces/$spaceId/pages/$pageId': typeof SpacesSpaceIdPagesPageIdRouteWithChildren
  '/spaces/$spaceId/pages/new': typeof SpacesSpaceIdPagesNewRoute
  '/spaces/$spaceId/pages/$pageId/edit': typeof SpacesSpaceIdPagesPageIdEditRoute
  '/spaces/$spaceId/pages/$pageId/': typeof SpacesSpaceIdPagesPageIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/events'
    | '/leaderboard'
    | '/members'
    | '/messages'
    | '/notifications'
    | '/profile'
    | '/search'
    | '/settings'
    | '/spaces'
    | '/admin/analytics'
    | '/admin/bans'
    | '/admin/default-pins'
    | '/admin/moderation'
    | '/admin/moderators'
    | '/messages/$partnerId'
    | '/posts/$postId'
    | '/posts/new'
    | '/profile/$userId'
    | '/spaces/$spaceId'
    | '/admin/'
    | '/messages/'
    | '/spaces/'
    | '/spaces/$spaceId/'
    | '/spaces/$spaceId/pages/$pageId'
    | '/spaces/$spaceId/pages/new'
    | '/spaces/$spaceId/pages/$pageId/edit'
    | '/spaces/$spaceId/pages/$pageId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/events'
    | '/leaderboard'
    | '/members'
    | '/notifications'
    | '/profile'
    | '/search'
    | '/settings'
    | '/admin/analytics'
    | '/admin/bans'
    | '/admin/default-pins'
    | '/admin/moderation'
    | '/admin/moderators'
    | '/messages/$partnerId'
    | '/posts/$postId'
    | '/posts/new'
    | '/profile/$userId'
    | '/admin'
    | '/messages'
    | '/spaces'
    | '/spaces/$spaceId'
    | '/spaces/$spaceId/pages/new'
    | '/spaces/$spaceId/pages/$pageId/edit'
    | '/spaces/$spaceId/pages/$pageId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/events'
    | '/leaderboard'
    | '/members'
    | '/messages'
    | '/notifications'
    | '/profile'
    | '/search'
    | '/settings'
    | '/spaces'
    | '/admin/analytics'
    | '/admin/bans'
    | '/admin/default-pins'
    | '/admin/moderation'
    | '/admin/moderators'
    | '/messages/$partnerId'
    | '/posts/$postId'
    | '/posts/new'
    | '/profile/$userId'
    | '/spaces/$spaceId'
    | '/admin/'
    | '/messages/'
    | '/spaces/'
    | '/spaces/$spaceId/'
    | '/spaces/$spaceId/pages/$pageId'
    | '/spaces/$spaceId/pages/new'
    | '/spaces/$spaceId/pages/$pageId/edit'
    | '/spaces/$spaceId/pages/$pageId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  EventsRoute: typeof EventsRoute
  LeaderboardRoute: typeof LeaderboardRoute
  MembersRoute: typeof MembersRoute
  MessagesRoute: typeof MessagesRouteWithChildren
  NotificationsRoute: typeof NotificationsRoute
  ProfileRoute: typeof ProfileRouteWithChildren
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  SpacesRoute: typeof SpacesRouteWithChildren
  PostsPostIdRoute: typeof PostsPostIdRoute
  PostsNewRoute: typeof PostsNewRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  EventsRoute: EventsRoute,
  LeaderboardRoute: LeaderboardRoute,
  MembersRoute: MembersRoute,
  MessagesRoute: MessagesRouteWithChildren,
  NotificationsRoute: NotificationsRoute,
  ProfileRoute: ProfileRouteWithChildren,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  SpacesRoute: SpacesRouteWithChildren,
  PostsPostIdRoute: PostsPostIdRoute,
  PostsNewRoute: PostsNewRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/admin",
        "/events",
        "/leaderboard",
        "/members",
        "/messages",
        "/notifications",
        "/profile",
        "/search",
        "/settings",
        "/spaces",
        "/posts/$postId",
        "/posts/new"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/admin": {
      "filePath": "admin.tsx",
      "children": [
        "/admin/analytics",
        "/admin/bans",
        "/admin/default-pins",
        "/admin/moderation",
        "/admin/moderators",
        "/admin/"
      ]
    },
    "/events": {
      "filePath": "events.tsx"
    },
    "/leaderboard": {
      "filePath": "leaderboard.tsx"
    },
    "/members": {
      "filePath": "members.tsx"
    },
    "/messages": {
      "filePath": "messages.tsx",
      "children": [
        "/messages/$partnerId",
        "/messages/"
      ]
    },
    "/notifications": {
      "filePath": "notifications.tsx"
    },
    "/profile": {
      "filePath": "profile.tsx",
      "children": [
        "/profile/$userId"
      ]
    },
    "/search": {
      "filePath": "search.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/spaces": {
      "filePath": "spaces.tsx",
      "children": [
        "/spaces/$spaceId",
        "/spaces/"
      ]
    },
    "/admin/analytics": {
      "filePath": "admin/analytics.tsx",
      "parent": "/admin"
    },
    "/admin/bans": {
      "filePath": "admin/bans.tsx",
      "parent": "/admin"
    },
    "/admin/default-pins": {
      "filePath": "admin/default-pins.tsx",
      "parent": "/admin"
    },
    "/admin/moderation": {
      "filePath": "admin/moderation.tsx",
      "parent": "/admin"
    },
    "/admin/moderators": {
      "filePath": "admin/moderators.tsx",
      "parent": "/admin"
    },
    "/messages/$partnerId": {
      "filePath": "messages/$partnerId.tsx",
      "parent": "/messages"
    },
    "/posts/$postId": {
      "filePath": "posts/$postId.tsx"
    },
    "/posts/new": {
      "filePath": "posts/new.tsx"
    },
    "/profile/$userId": {
      "filePath": "profile/$userId.tsx",
      "parent": "/profile"
    },
    "/spaces/$spaceId": {
      "filePath": "spaces/$spaceId.tsx",
      "parent": "/spaces",
      "children": [
        "/spaces/$spaceId/",
        "/spaces/$spaceId/pages/$pageId",
        "/spaces/$spaceId/pages/new"
      ]
    },
    "/admin/": {
      "filePath": "admin/index.tsx",
      "parent": "/admin"
    },
    "/messages/": {
      "filePath": "messages/index.tsx",
      "parent": "/messages"
    },
    "/spaces/": {
      "filePath": "spaces/index.tsx",
      "parent": "/spaces"
    },
    "/spaces/$spaceId/": {
      "filePath": "spaces/$spaceId/index.tsx",
      "parent": "/spaces/$spaceId"
    },
    "/spaces/$spaceId/pages/$pageId": {
      "filePath": "spaces/$spaceId/pages/$pageId.tsx",
      "parent": "/spaces/$spaceId",
      "children": [
        "/spaces/$spaceId/pages/$pageId/edit",
        "/spaces/$spaceId/pages/$pageId/"
      ]
    },
    "/spaces/$spaceId/pages/new": {
      "filePath": "spaces/$spaceId/pages/new.tsx",
      "parent": "/spaces/$spaceId"
    },
    "/spaces/$spaceId/pages/$pageId/edit": {
      "filePath": "spaces/$spaceId/pages/$pageId/edit.tsx",
      "parent": "/spaces/$spaceId/pages/$pageId"
    },
    "/spaces/$spaceId/pages/$pageId/": {
      "filePath": "spaces/$spaceId/pages/$pageId/index.tsx",
      "parent": "/spaces/$spaceId/pages/$pageId"
    }
  }
}
ROUTE_MANIFEST_END */
